var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52105 4.83684V8.31053H11.9947C12.277 8.31053 12.5158 8.54934 12.5158 8.83158C12.5158 9.13553 12.277 9.35263 11.9947 9.35263H8.52105V12.8263C8.52105 13.1303 8.28224 13.3474 8 13.3474C7.69605 13.3474 7.47895 13.1303 7.47895 12.8263V9.35263H4.00526C3.70132 9.35263 3.48421 9.13553 3.48421 8.83158C3.48421 8.54934 3.70132 8.31053 4.00526 8.31053H7.47895V4.83684C7.47895 4.5546 7.69605 4.31579 8 4.31579C8.28224 4.31579 8.52105 4.5546 8.52105 4.83684Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.87f00da145607166183d85e6cd40f338.svg";
export { ForwardRef as ReactComponent };